import { render, staticRenderFns } from "./ReceiptStage2.vue?vue&type=template&id=01cc1f46&scoped=true&"
import script from "./ReceiptStage2.vue?vue&type=script&lang=js&"
export * from "./ReceiptStage2.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptStage2.vue?vue&type=style&index=0&id=01cc1f46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc1f46",
  null
  
)

export default component.exports